import React, { useState } from 'react';

/**
 * SpeakButton — wraps the Web Speech API to speak German text aloud.
 * @param {string} text - Text to speak
 * @param {string} lang - BCP-47 language code (default: 'de-DE')
 * @param {string} className - Extra CSS classes
 */
const SpeakButton = ({ text, lang = 'de-DE', className = '' }) => {
  const [speaking, setSpeaking] = useState(false);

  if (!('speechSynthesis' in window)) return null;

  const speak = (e) => {
    e.stopPropagation();
    if (speaking) {
      window.speechSynthesis.cancel();
      setSpeaking(false);
      return;
    }

    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = lang;
    utter.rate = 0.9;
    utter.pitch = 1;

    // Try to pick a German voice if available
    const voices = window.speechSynthesis.getVoices();
    const deVoice = voices.find((v) => v.lang.startsWith('de'));
    if (deVoice) utter.voice = deVoice;

    utter.onstart = () => setSpeaking(true);
    utter.onend = () => setSpeaking(false);
    utter.onerror = () => setSpeaking(false);

    window.speechSynthesis.speak(utter);
  };

  return (
    <button
      type="button"
      onClick={speak}
      title={speaking ? 'Ndalo' : `Dëgjo: "${text}"`}
      aria-label={speaking ? 'Ndalo zërin' : `Lexo me zë: ${text}`}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-full transition-all duration-200 cursor-pointer ${
        speaking
          ? 'bg-blue-100 text-blue-600 animate-pulse'
          : 'text-zinc-400 hover:text-blue-600 hover:bg-blue-50'
      } ${className}`}
    >
      {speaking ? (
        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="6" y="4" width="4" height="16" rx="1" />
          <rect x="14" y="4" width="4" height="16" rx="1" />
        </svg>
      ) : (
        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
        </svg>
      )}
    </button>
  );
};

export default SpeakButton;
